import calls from '@/backend/api-calls'
import { parseJSON } from 'date-fns'

const state = () => ({
  proposal: null,
  project: null,
  syncing: false,
  saveCount: 1,
  loading: false
})

// getters
const getters = {
}

// actions
const actions = {
  getProject: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      commit("setLoading", true);

      calls.project.get(id)
        .then(resp => {
          commit("setProject", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  getProposal: ({commit}, {projectId, proposalId}) => {
    calls.proposal.get(projectId, proposalId)
      .then(resp => {
        commit("setProposal", resp.data);
      })
  },
  sync: ({commit, dispatch}, crmId) => {
    commit('setSyncState', true)
    calls.projects.sync({ crm_id: crmId })
      .then(resp => dispatch("syncSuccess", resp))
  },
  syncSuccess: ({commit}) => {
    setTimeout(() => {
      commit('setSyncState', false);

      commit(
        'app/setNotification',
        {
          status: true,
          type: 'success',
          message: 'Sync request sent, please refresh your browser in a few minutes to see updated data.'
        },
        { root: true }
      );
    }, 1000);
  },
}

// mutations
const mutations = {
  setLoading (state, value) {
    state.loading = value;
  },
  setProposal (state, data) {
    data = data ? _processProposal(state.project, data) : null
    state.proposal = data;
  },
  setProject (state, data) {
    state.project = data;
  },
  updateProposalObject (state, data) {
    state.proposal.proposal_object = data;
  },
  setSyncState (state, data) {
    state.syncing = data;
  },
  incSaveCount (state) {
    state.saveCount += 1;
  },
  updateProposalName (state, data) {
    state.proposal.proposal_object.name = data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

function _processDates (proposalObj) {
  if (proposalObj.project_info.date.value) {
    proposalObj.project_info.date.value = proposalObj.project_info.date.value ? 
      parseJSON(proposalObj.project_info.date.value) : null;
  }

  proposalObj.sent_on = proposalObj.sent_on ? parseJSON(proposalObj.sent_on) : proposalObj.sent_on;

  proposalObj.proposal_info.forEach(section => {
    if (section.label == 'Documents') {
      section.value.forEach(
        doc => {
          if (doc.date_received) {
            doc.date_received = parseJSON(doc.date_received);
          }
          if (doc.received_on) {
            doc.received_on = parseJSON(doc.received_on);
          }
        }
      )
    }
  })

  return proposalObj;
}

function _processProposal (project, proposal) {
  proposal.proposal_object = _processDates(proposal.proposal_object);

  proposal.proposal_object.project_info.sales_person.value = {
    'From': project.crm_object.Owner.name,
    'Phone': project.sales_person_primary_phone,
    'Mobile': project.sales_person_secondary_phone,
    'Email': project.crm_object.Owner.email,
    'Estimator': 'Neda Emam'
  }

  if (project.crm_object.Contact_Roles) {
    proposal.proposal_object.project_info.contact.bind.options = [];
    project.crm_object.Contact_Roles.forEach(contact => {
      proposal.proposal_object.project_info.contact.bind.options.push({
        'To': contact.Account_Name ? contact.Account_Name.name : null,
        'Name': contact.Full_Name,
        'Phone': contact.Phone,
        'Email': contact.Email,
        'Quote No.': proposal.proposal_object.project_info.contact.value['Quote No.']
      })
    })
  }

  proposal.proposal_object.project_info.name.value = project.project_name;
  // Comment out address so it doesn't update every time - this way it won't save on top of what the sales person put
  // proposal.proposal_object.project_info.address.value = project.crm_object.Address;

  return proposal
}
